import { FormattedMessage } from "react-intl";

import { SignupBackgroundLayout } from "@/components/signup/layouts";
import SiteActivation, {
    ReturnToProduct
} from "@/components/signup/site-activation";
import { ServiceCollectionLogo } from "@/components/signup/utils";

import { SubHeading, WelcomeBackHeading } from "../components";

export const CurrentProductUser = () => (
    <SignupBackgroundLayout
        ProductLogo={<ServiceCollectionLogo />}
        theme="yellow"
    >
        <WelcomeBackHeading />
        <SubHeading>
            <FormattedMessage
                id="return-to-product-modal.header.text"
                defaultMessage="Pick up where you left off."
            />
        </SubHeading>
        {/* everyone with a service collection should see a return to product experience */}
        <SiteActivation CurrentProductUser={<ReturnToProduct />} />
    </SignupBackgroundLayout>
);
